import PhaseSixIcon from "../phaseSixIcon/PhaseSixIcon";

interface BackNavigationButtonProps {
    label: string;
    onClick: () => void;
}

const BackNavigationButton = (props: BackNavigationButtonProps) => {
    return (
        <div className="self-start">
            <button
                type="button"
                data-testid="back-navigation-button"
                onClick={props.onClick}
                className="flex gap-xs items-center cursor-pointer bg-transparent border-none p-no"
            >
                <PhaseSixIcon
                    name="chevron-left"
                    className="text-xl text-p6-grey-dark"
                />
                <span className="text-l text-p6-grey-dark">{props.label}</span>
            </button>
        </div>
    );
};

export default BackNavigationButton;
